/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Error_GenericInputs */

const de_auth_mfa_error_generic = /** @type {(inputs: Auth_Mfa_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.`)
};

/** @type {(inputs: Auth_Mfa_Error_GenericInputs) => LocalizedString} */
const en_auth_mfa_error_generic = de_auth_mfa_error_generic;

/**

* @param {Auth_Mfa_Error_GenericInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_error_generic = /** @type {((inputs?: Auth_Mfa_Error_GenericInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Error_GenericInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_error_generic(inputs)
	return en_auth_mfa_error_generic(inputs)
});